<template>
  <div class="d-flex justify-between align-center">
    <div class="d-flex align-center">
      <tm-skeleton-avatar
        v-if="!isMobile"
        custom-size="44px"
        class="mr-3"
      />

      <div>
        <tm-skeleton
          type="text"
          width="173px"
          height="24px"
        />
        <tm-skeleton
          width="105px"
          height="20px"
          type="text"
          class="mt-1"
        />
      </div>
    </div>
    <div class="d-flex gt-sm">
      <tm-skeleton
        v-for="i in preparedBtnCount"
        :key="i"
        width="93px"
        height="22px"
        type="QChip"
        class="ml-2"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from '@/composition/vue/compositionApi'
import TmSkeleton from '@/components/shared/skeletons/TmSkeleton.vue'
import { useBreakpoints } from '@/composition/breakpoints'
import TmSkeletonAvatar from '@/components/shared/skeletons/TmSkeletonAvatar.vue'

const props = defineProps<{
  btnCount?: number
}>()

const { isMobile, isTablet, isLargeLaptop } = useBreakpoints()

const preparedBtnCount = computed(() => {
  if (props.btnCount !== undefined) {
    return props.btnCount
  }
  if (isTablet.value) {
    return 2
  }
  if (isLargeLaptop.value) {
    return 3
  }

  return 5
})
</script>
